import React from 'react';
import ScannerDetail from '~/components/AgentScanners/components/ScannerDetail';
import NavigationSidebar from '~/components/NavigationSidebar';
import BaseLayout from '~/layouts/BaseLayout';

class ScannerDetailLayout extends BaseLayout {
  renderSidebar() {
    return <NavigationSidebar />;
  }

  renderMain() {
    return <ScannerDetail />;
  }
}

export default ScannerDetailLayout;
